import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { SwipeableDrawer, SwipeableDrawerProps, useTheme } from '@mui/material';
import { captureException } from '@sentry/react';
import { PropsWithChildren, useEffect } from 'react';

export interface SideDrawerProps {
  openState: boolean;
  toggleDrawer(state: boolean): void;
  drawerProps?: Partial<SwipeableDrawerProps>;
  paperProps?: Partial<SwipeableDrawerProps['PaperProps']>;
}

export const SideDrawer = (props: PropsWithChildren<SideDrawerProps>) => {
  const theme = useTheme();
  useEffect(() => {
    if (props.openState && Capacitor.getPlatform() === 'android') {
      const listener = App.addListener('backButton', () => {
        props.toggleDrawer(false);
      });

      return () => {
        listener
          .then((handle) => handle.remove())
          .catch((error) => {
            console.error(error);
            captureException(error);
          });
      };
    }

    return undefined;
  }, [props.openState, props.toggleDrawer]);

  return (
    <SwipeableDrawer
      open={props.openState}
      onOpen={() => props.toggleDrawer(true)}
      onClose={() => props.toggleDrawer(false)}
      PaperProps={{
        ...props.paperProps,
        sx: {
          pt: `calc(var(--safe-area-inset-top) + ${theme.spacing(2)})`,
          pb: `max(var(--safe-area-inset-bottom), ${theme.spacing(4)})`,
          px: theme.spacing(3),
          minWidth: '280px',
          width: '80vw',
          maxWidth: '320px',
          ...props.paperProps?.sx,
        },
      }}
      anchor="left"
      disableSwipeToOpen
      disableDiscovery
      {...props.drawerProps}
    >
      {props.children}
    </SwipeableDrawer>
  );
};
